import { render, staticRenderFns } from "./salesContractDetail.vue?vue&type=template&id=5ddb86af&scoped=true"
import script from "./salesContractDetail.vue?vue&type=script&lang=js"
export * from "./salesContractDetail.vue?vue&type=script&lang=js"
import style0 from "./salesContractDetail.vue?vue&type=style&index=0&id=5ddb86af&prod&lang=scss&scoped=true"
import style1 from "./salesContractDetail.vue?vue&type=style&index=1&id=5ddb86af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb86af",
  null
  
)

export default component.exports